import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-dots-icon',
  templateUrl: './text-dots.component.html'
})
export class TextDotsComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
